<template>
  <div class="layout-subcontainer">
    <h1 class="tit-h1">채팅사용자별 상담통계</h1>
    <div class="box-wrap">
      <div class="box-ct d-flex">
        <div>
          <div>
            <div class="form-inp sm">
              <v-select
                :items="ASP_CUST_KEY"
                item-value="CD"
                item-text="CD_NM"
                outlined
                hide-details
                label="회사구분"
                placeholder="선택하세요"
                v-model="ASP_NEWCUST_KEY"
                v-on:change="chnASP"
                :readonly="RDOnly"
              >
                <template v-slot:label>
                  회사구분
                  <v-icon color="#EF9191">mdi-circle-small</v-icon>
                </template>
              </v-select>
            </div>
            <div class="form-inp sm ml-2">
              <v-select
                :items="SEARCH_TY"
                item-value="CD"
                item-text="NM"
                outlined
                hide-details
                placeholder="선택하세요"
                v-model="SEARCH_NEWTY"
                v-on:change="chkInqTY()"
              >
                <template v-slot:label> 조회유형 </template>
              </v-select>
            </div>
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
              content-class="calendar-modal"
              color="#FFF"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  v-bind="attrs"
                  v-on="on"
                  readonly
                  outlined
                  hide-details
                  class="form-inp icon-calendar ml-2"
                  append-icon="svg-calendar"
                  label="조회기간"
                ></v-text-field>
              </template>
              <div class="datepicker-range">
                <v-date-picker
                  v-model="dates[0]"
                  no-title
                  dark
                  color="#F7AFAE"
                  @change="startDate"
                  :first-day-of-week="1"
                  locale="ko-KR"
                  :day-format="mixin_getDate"
                ></v-date-picker>
                <v-date-picker
                  v-model="dates[1]"
                  dark
                  color="#F7AFAE"
                  no-title
                  show-current="false"
                  :min="dates[0]"
                  @change="endDate"
                  :first-day-of-week="1"
                  locale="ko-KR"
                  :day-format="mixin_getDate"
                ></v-date-picker>
              </div>
              <div class="text-center pt-3 pb-3">
                <v-btn
                  outlined
                  class="btn-default"
                  @click="menu1 = false"
                  >확인</v-btn
                >
              </div>
            </v-menu>
            <div class="form-inp ml-2">
              <v-select
                :items="ASP_SENDER_KEY"
                item-value="CD"
                item-text="NM"
                outlined
                hide-details
                placeholder="선택하세요"
                v-model="ASP_NEWSENDER_KEY"
              >
                <template v-slot:label> 채널 </template>
              </v-select>
            </div>
            <v-text-field
              class="form-inp sm ml-2"
              name="name"
              label="사용자 ID"
              outlined
              hide-details
              v-model="USER_ID"
            >
            </v-text-field>
            <v-text-field
              class="form-inp sm ml-2"
              name="name"
              label="사용자 이름"
              outlined
              hide-details
              v-model="USER_NM"
            >
            </v-text-field>
            <v-text-field
              class="form-inp sm ml-2"
              name="name"
              label="사용자 닉네임"
              outlined
              hide-details
              v-model="USER_NICK"
            >
            </v-text-field>
            <!-- 조회 버튼 -->
            <v-btn 
              v-if="this.mixin_set_btn(this.$options.name, 'btnPopupUser')"
              dark small
              class="btn-main-search pa-0 ml-2" min-width="32px" height="32px" plain
              @click="[btnUser(), showDialog('MP02')]">
              <v-icon small class="svg-main-searh white"></v-icon>
            </v-btn>
            <!-- 새로고침 버튼 -->
            <v-btn 
              v-if="this.mixin_set_btn(this.$options.name, 'btnInitUser')"
              dark small
              class="btn-main-refresh pa-0 ml-2" min-width="32px" height="32px"
              @click="initUser"
              plain
              >
              <v-icon small class="svg-main-refresh"></v-icon>
            </v-btn>
          </div>
          <div class="mt-2">
            <div class="form-inp sm">
              <v-select
                :items="USER_ATTR_A"
                item-value="CD"
                item-text="CD_NM"
                outlined
                hide-details
                placeholder="선택하세요"
                v-model="USER_NEWATTR_A"
              >
                <template v-slot:label> 소속 </template>
              </v-select>
            </div>
            <div class="form-inp sm ml-2">
              <v-select
                :items="USER_ATTR_B"
                item-value="CD"
                item-text="CD_NM"
                outlined
                hide-details
                placeholder="선택하세요"
                v-model="USER_NEWATTR_B"
              >
                <template v-slot:label> 소속 </template>
              </v-select>
            </div>
            <div class="form-inp sm ml-2">
              <v-select
                :items="USER_ATTR_C"
                item-value="CD"
                item-text="CD_NM"
                outlined
                hide-details
                placeholder="선택하세요"
                v-model="USER_NEWATTR_C"
              >
                <template v-slot:label> 소속 </template>
              </v-select>
            </div>
            <div class="form-inp sm ml-2">
              <v-select
                :items="USER_ATTR_D"
                item-value="CD"
                item-text="CD_NM"
                outlined
                hide-details
                placeholder="선택하세요"
                v-model="USER_NEWATTR_D"
              >
                <template v-slot:label> 소속 </template>
              </v-select>
            </div>
            <div class="form-inp sm ml-2">
              <v-select
                :items="ATRT_USER_GP"
                item-value="CD"
                item-text="CD_NM"
                outlined
                hide-details
                placeholder="선택하세요"
                v-model="ATRT_NEWUSER_GP"
              >
                <template v-slot:label> 사용자권한 </template>
              </v-select>
            </div>
          </div>
          <div class="mt-2">
            <div class="form-inp free">
              <v-select
                single-line
                v-model="CHK_NEWDAY"
                :items="CHK_DAY"
                item-value="value"
                item-text="text"
                outlined
                label="요일"
                multiple
                hide-details
                v-on:change="[chgChkDay(),chkNoDay()]"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip small>
                    <span>{{ item.text }}</span>
                    <template>
                      <v-btn
                        icon
                        x-small
                        class="svg-close20 ml-1"
                        v-show="dropItemRemove === true"
                        @click.stop="removeDropDay(item)"
                      ></v-btn>
                    </template>
                  </v-chip>
                </template>
              </v-select>
            </div>
            <div class="form-inp free ml-2">
              <v-select
                single-line
                v-model="CHK_NEWTIME"
                :items="CHK_TIME"
                item-value="value"
                item-text="text"
                outlined
                label="조회시간"
                multiple
                hide-details
                v-on:change="[chgChkTime(),chkNoTime()]"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index < 4" small>
                    <span>{{ item.text }}</span>
                    <template>
                      <v-btn
                        icon
                        x-small
                        class="svg-close20 ml-1"
                        v-show="dropItemRemove === true"
                        @click.stop="removeDropTime(item)"
                      ></v-btn>
                    </template>
                  </v-chip>
                  <span v-if="index === 3" class="grey--text text-caption">
                    ...
                  </span>
                </template>
              </v-select>
            </div>
            <v-btn v-if="this.mixin_set_btn(this.$options.name, 'btnAllCheck')" outlined class="btn-default ml-2" @click="allClick"
              >전체선택</v-btn
            >
            <v-btn v-if="this.mixin_set_btn(this.$options.name, 'btnAllUncheck')" outlined class="btn-default ml-2" @click="[allCloseClick(),chkNoTime()]"
              >전체해제</v-btn
            >
            <v-btn v-if="this.mixin_set_btn(this.$options.name, 'btnWork')" outlined class="btn-default ml-2" @click="selectTime"
              >업무시간선택</v-btn
            >
            <v-btn v-if="this.mixin_set_btn(this.$options.name, 'btnTurn')" outlined class="btn-default ml-2" @click="selectTurn"
              >선택반전</v-btn
            >
          </div>
        </div>
        <div class="ml-auto align-self-center">
          <v-btn v-if="this.mixin_set_btn(this.$options.name, 'btnSearch')" outlined class="btn-etc2" v-on:click="selectList">
            조회
          </v-btn>
        </div>
      </div>
    </div>
    <div class="box-wrap">
      <h2 class="tit-h2 mt-3">리스트</h2>
      <div class="box-ct">
        <v-data-table
          dense
          height="423px"
          :headers="gridDataHeaders"
          :items="gridDataText"
          :items-per-page="30"
          item-key="index"
          :page.sync="page"
          hide-default-header
          hide-default-footer
          class="grid-default"
          calculate-widths
          @page-count="pageCount = $event"
          @click:row="rowClick"
          single-select
          no-data-text="통계 결과가 없습니다."
          :item-class="isActiveRow"
          fixed-header
        >
          <template v-slot:header>
            <thead class="v-data-table-header">
              <tr>
                <th scope="row" rowspan="2" class="text-center">NO</th>
                <th scope="row" rowspan="2" class="text-center">회사명</th>
                <th scope="row" colspan="4" class="text-center">사용자정보</th>
                <th scope="row" rowspan="2" class="text-center">배정</th>
                <th scope="row" colspan="3" class="text-center">상담진행</th>
                <th scope="row" rowspan="2" class="text-center">
                  고객대기중포기
                </th>
                <th scope="row" rowspan="2" class="text-center">
                  상담응대율[%]
                </th>
                <th scope="row" colspan="7" class="text-center">상태별시간</th>
                <th scope="row" colspan="3" class="text-center">
                  평균상담시간
                </th>
              </tr>
              <tr>
                <th scope="row" class="text-center">ID</th>
                <th scope="row" class="text-center">성명</th>
                <th scope="row" class="text-center">닉네임</th>
                <th scope="row" class="text-center">소속</th>
                <th scope="row" class="text-center">총상담처리</th>
                <th scope="row" class="text-center">상담</th>
                <th scope="row" class="text-center">전달</th>
                <th scope="row" class="text-center">채팅ON</th>
                <th scope="row" class="text-center">채팅OFF</th>
                <th scope="row" class="text-center">휴식</th>
                <th scope="row" class="text-center">식사</th>
                <th scope="row" class="text-center">교육</th>
                <th scope="row" class="text-center">회의</th>
                <th scope="row" class="text-center">추가업무</th>
                <th scope="row" class="text-center">평균상담시간</th>
                <th scope="row" class="text-center">평균후처리시간</th>
                <th scope="row" class="text-center">평균처리시간</th>
              </tr>
            </thead>
          </template>
          <template slot="body.append" v-if="gridDataText.length > 0">
            <tr class="grid-default-sum">
              <td class="grid-default-sum--head text-center" colspan="6">
                합계
              </td>
              <td class="text-center">
                {{ mixin_sum_field(this.gridDataText, "NUMBER_ASSIGNMENT") }}
              </td>
              <td class="text-center">
                {{ mixin_sum_field(this.gridDataText, "NUMBER_TOT_PROGRESS") }}
              </td>
              <td class="text-center">
                {{ mixin_sum_field(this.gridDataText, "NUMBER_PROGRESS") }}
              </td>
              <td class="text-center">
                {{ mixin_sum_field(this.gridDataText, "NUMBER_RELAY") }}
              </td>
              <td class="text-center">
                {{
                  mixin_sum_field(
                    this.gridDataText,
                    "NUMBER_CUSTOMER_GIVE_UP_92"
                  )
                }}
              </td>
              <td class="text-center">
                {{
                  mixin_avg_field(
                    this.gridDataText,
                    "NUMBER_TOT_PROGRESS",
                    "NUMBER_ASSIGNMENT"
                  )
                }}
              </td>
              <td class="text-center">
                {{ mixin_date_sum_field(this.gridDataText, "S_CHATON") }}
              </td>
              <td class="text-center">
                {{ mixin_date_sum_field(this.gridDataText, "S_CHATOFF") }}
              </td>
              <td class="text-center">
                {{ mixin_date_sum_field(this.gridDataText, "S_REST") }}
              </td>
              <td class="text-center">
                {{ mixin_date_sum_field(this.gridDataText, "S_MEAL") }}
              </td>
              <td class="text-center">
                {{ mixin_date_sum_field(this.gridDataText, "S_EDU") }}
              </td>
              <td class="text-center">
                {{ mixin_date_sum_field(this.gridDataText, "S_MEETING") }}
              </td>
              <td class="text-center">
                {{ mixin_date_sum_field(this.gridDataText, "S_ADDWORK") }}
              </td>
              <td class="text-center">
                {{ mixin_date_avg_field(this.gridDataText, "AVG_CHATTING") }}
              </td>
              <td class="text-center">
                {{
                  mixin_date_avg_field(this.gridDataText, "AVG_AFTER_TREATMENT")
                }}
              </td>
              <td class="text-center">
                {{
                  mixin_date_avg_field(
                    this.gridDataText,
                    "AVG_CHATTING_AFTER_TREATMENT"
                  )
                }}
              </td>
            </tr>
          </template>
        </v-data-table>
        <div
          class="grid-paging text-center pt-2"
          v-if="gridDataText.length > 0"
        >
          <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="totalVisible"
            next-icon="svg-paging-next"
            prev-icon="svg-paging-prev"
          ></v-pagination>
        </div>
        <p class="caption text-right">
          <strong class="clr-error">{{ gridDataText.length }}</strong
          >건의 통계가 검색되었습니다.
        </p>
      </div>
    </div>

    <!-- 고객정보 모달창 -->
    <div class="">
      <v-dialog
        max-width="1400"
        max-height="1200"
        v-model="DialogMP02"
        content-class="square-modal"
      >
        <dialog-MP02
          headerTitle="고객정보"
          @hide="hideDialog('MP02')"
          :userInfo="userInfo"
          @input="userInfo = $event"
          @selectUser="[hideDialog('MP02'), setUser()]"
        >
        </dialog-MP02>
        <template v-slot:body> </template>
      </v-dialog>
    </div>
    <!-- 고객정보 모달창 -->
  </div>
</template>

<script>
import api from "../../store/apiUtil.js";
import { mixin } from "@/mixin/mixin.js";
import DialogMP02 from "./MP02.vue";

export default {
  name: "MENU_M710201", //name은 'MENU_' + 파일명 조합
  mixins: [mixin],
  components: {
    DialogMP02,
  },
  data() {
    return {
      DialogMP02: false,
      userInfo: {},
      menu1: false,
      dropItemRemove: true,
      dates: [
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
      ],
      gridDataHeaders: [
        {
          text: "No",
          align: "center",
          value: "index",
          width: "50px",
          sortable: false,
        },
        { text: "", value: "COMPANY_NM", align: "center", sortable: false },
        { text: "", value: "USER_ID", align: "center", sortable: false },
        { text: "", value: "USER_NM", align: "center", sortable: false },
        { text: "", value: "USER_NICK", align: "center", sortable: false },
        { text: "", value: "ATTR_DIV_NM_AC", align: "center", sortable: false },
        {
          text: "",
          value: "NUMBER_ASSIGNMENT",
          align: "center",
          sortable: false,
        },
        {
          text: "",
          value: "NUMBER_TOT_PROGRESS",
          align: "center",
          sortable: false,
        },
        {
          text: "",
          value: "NUMBER_PROGRESS",
          align: "center",
          sortable: false,
        },
        { text: "", value: "NUMBER_RELAY", align: "center", sortable: false },
        {
          text: "",
          value: "NUMBER_CUSTOMER_GIVE_UP_92",
          align: "center",
          sortable: false,
        },
        { text: "", value: "RATE_RESPONSE", align: "center", sortable: false },
        { text: "", value: "S_CHATON", align: "center", sortable: false },
        { text: "", value: "S_CHATOFF", align: "center", sortable: false },
        { text: "", value: "S_REST", align: "center", sortable: false },
        { text: "", value: "S_MEAL", align: "center", sortable: false },
        { text: "", value: "S_EDU", align: "center", sortable: false },
        { text: "", value: "S_MEETING", align: "center", sortable: false },
        { text: "", value: "S_ADDWORK", align: "center", sortable: false },
        { text: "", value: "AVG_CHATTING", align: "center", sortable: false },
        {
          text: "",
          value: "AVG_AFTER_TREATMENT",
          align: "center",
          sortable: false,
        },
        {
          text: "",
          value: "AVG_CHATTING_AFTER_TREATMENT",
          align: "center",
          sortable: false,
        },
      ],
      gridDataText: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 5,
      totalVisible: 10,

      ASP_CUST_KEY: this.$store.getters["userStore/GE_USER_ROLE"].company,

      SEARCH_TY: [
        {
          CD: "TIME",
          NM: "시간"
        },
        {
          CD: "DAY",
          NM: "일",
        },
        {
          CD: "MONTH",
          NM: "월",
        },
        {
          CD: "YEAR",
          NM: "년",
        },
        {
          CD: "DAY_OF_THE_WEEK",
          NM: "요일",
        },
      ],

      ASP_SENDER_KEY: [
        {
          CD: "",
          NM: "전체",
        },
      ],

      INQ_TYP_1: [
        {
          CD: "",
          CD_NM: "전체",
        },
      ],

      INQ_TYP_2: [
        {
          CD: "",
          CD_NM: "전체",
        },
      ],

      USER_ATTR_A: [
        {
          CD: "",
          CD_NM: "전체",
        },
      ],

      USER_ATTR_B: [
        {
          CD: "",
          CD_NM: "전체",
        },
      ],

      USER_ATTR_C: [
        {
          CD: "",
          CD_NM: "전체",
        },
      ],

      USER_ATTR_D: [
        {
          CD: "",
          CD_NM: "전체",
        },
      ],

      ATRT_USER_GP: [
        {
          CD: "",
          CD_NM: "전체",
        },
      ],

      CHK_DAY: [
        {
          text: "일",
          value: "1",
        },
        {
          text: "월",
          value: "2",
        },
        {
          text: "화",
          value: "3",
        },
        {
          text: "수",
          value: "4",
        },
        {
          text: "목",
          value: "5",
        },
        {
          text: "금",
          value: "6",
        },
        {
          text: "토",
          value: "7",
        },
      ],

      CHK_TIME: [
        {
          text: "00시",
          selected: true,
          value: "00",
        },
        {
          text: "01시",
          selected: true,
          value: "01",
        },
        {
          text: "02시",
          selected: true,
          value: "02",
        },
        {
          text: "03시",
          selected: true,
          value: "03",
        },
        {
          text: "04시",
          selected: true,
          value: "04",
        },
        {
          text: "05시",
          selected: true,
          value: "05",
        },
        {
          text: "06시",
          selected: true,
          value: "06",
        },
        {
          text: "07시",
          selected: true,
          value: "07",
        },
        {
          text: "08시",
          selected: true,
          value: "08",
        },
        {
          text: "09시",
          selected: true,
          value: "09",
        },
        {
          text: "10시",
          selected: true,
          value: "10",
        },
        {
          text: "11시",
          selected: true,
          value: "11",
        },
        {
          text: "12시",
          selected: true,
          value: "12",
        },
        {
          text: "13시",
          selected: true,
          value: "13",
        },
        {
          text: "14시",
          selected: true,
          value: "14",
        },
        {
          text: "15시",
          selected: true,
          value: "15",
        },
        {
          text: "16시",
          selected: true,
          value: "16",
        },
        {
          text: "17시",
          selected: true,
          value: "17",
        },
        {
          text: "18시",
          selected: true,
          value: "18",
        },
        {
          text: "19시",
          selected: true,
          value: "19",
        },
        {
          text: "20시",
          selected: true,
          value: "20",
        },
        {
          text: "21시",
          selected: true,
          value: "21",
        },
        {
          text: "22시",
          selected: true,
          value: "22",
        },
        {
          text: "23시",
          selected: true,
          value: "23",
        },
      ],

      ASP_NEWCUST_KEY: "",
      SEARCH_NEWTY: "DAY",
      ASP_NEWSENDER_KEY: "",
      INQ_NEWTYP_1: "",
      INQ_NEWTYP_2: "",
      USER_ID: "",
      USER_NM: "",
      USER_NICK: "",
      USER_NEWATTR_A: "",
      USER_NEWATTR_B: "",
      USER_NEWATTR_C: "",
      USER_NEWATTR_D: "",
      ATRT_NEWUSER_GP: "",

      CHK_NEWDAY: ["1", "2", "3", "4", "5", "6", "7"],
      CHK_NEWTIME: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
      ],

      ROW_DATA:{},

      RDOnly:false,
    };
  },

  mounted(){
    let chk = this.mixin_check_AspCustKey_number();
    if(chk == 'Y'){
      this.ASP_NEWCUST_KEY = this.$store.getters["userStore/GE_USER_ROLE"].company[0].CD;
      this.RDOnly = true;
    } else {
      this.RDOnly = false;
    }
  },

  created() {
    this.getAspAuth();
  },

  methods: {
    startDate(e) {
      this.dates[0] = e;
    },
    endDate(e) {
      this.dates[1] = e;
    },

    removeDropDay(item) {
      this.CHK_NEWDAY.splice((item.value-1), 1);

      let DayArray = this.CHK_NEWDAY;
      this.CHK_NEWDAY = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ]
      for(let i = 0; i < DayArray.length; i++){
        if(DayArray[i] != "" || DayArray[i] != null){
          let m = parseInt(DayArray[i]);
          this.CHK_NEWDAY[m-1] = DayArray[i];
        }
      }

      this.chkNoDay();
    },

    removeDropTime(item) {
      this.CHK_NEWTIME.splice(parseInt(item.value), 1);

      let TimeArray = this.CHK_NEWTIME;
      this.CHK_NEWTIME = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ]
      for(let i = 0; i < TimeArray.length; i++){
        if(TimeArray[i] != "" || TimeArray[i] != null){
          let m = parseInt(TimeArray[i]);
          this.CHK_NEWTIME[m] = TimeArray[i];
        }
      }

      this.chkNoTime();
    },

    //회사 구분에 콤보박스 조회
    async chnASP() {
      var date = new Date("00:00:01");

      var user = { ASP_CUST_KEY: this.ASP_NEWCUST_KEY };
      this.userInfo = user;
      this.USER_ATTR_A = [{ CD: "", CD_NM: "전체" }];
      this.USER_ATTR_B = [{ CD: "", CD_NM: "전체" }];
      this.USER_ATTR_C = [{ CD: "", CD_NM: "전체" }];
      this.USER_ATTR_D = [{ CD: "", CD_NM: "전체" }];
      this.getAttrDiv("A");
      this.getAttrDiv("B");
      this.getAttrDiv("C");
      this.getAttrDiv("D");
      this.ASP_SENDER_KEY = [{ CD: "", NM: "전체"}];
      let sender = await this.mixin_channel_get(this.ASP_NEWCUST_KEY);
      this.ASP_SENDER_KEY = [...this.ASP_SENDER_KEY, ...sender];
    },

    //사용자 소속 콤보박스 생성
    getAttrDiv(attr) {
      api
        .post(
          "api/palette/common/get-attr-div/list", //api url입력
          {
            ASP_NEWCUST_KEY: this.ASP_NEWCUST_KEY,
            ATTR_CD: attr,
            ATTR_DIV_CD: "",
            ASP_USER_ID: this.$store.getters["userStore/GE_USER_ROLE"].userId,
            ASP_CUST_KEY:
              this.$store.getters["userStore/GE_USER_ROLE"].company[0].CD,
          },
          {
            head: {
              SERVICE: "palette.common.get-attr-div",
              METHOD: "list",
              TYPE: "BIZ_SERVICE",
            },
          }
        )
        .then((response) => {
          console.log(response.data.DATA);
          if (attr == "A") {
            this.USER_ATTR_A = [...this.USER_ATTR_A, ...response.data.DATA];
          } else if (attr == "B") {
            this.USER_ATTR_B = [...this.USER_ATTR_B, ...response.data.DATA];
          } else if (attr == "C") {
            this.USER_ATTR_C = [...this.USER_ATTR_C, ...response.data.DATA];
          } else if (attr == "D") {
            this.USER_ATTR_D = [...this.USER_ATTR_D, ...response.data.DATA];
          }
        })
        .catch((err) => {
          alert(err);
        });
    },

    //사용자 권한 콤보박스 생성
    getAspAuth() {
      api
        .post(
          "api/statistics/chat/counsel-by-agent/combobox/inqire", //api url입력
          {
            ASP_NEWCUST_KEY: this.ASP_NEWCUST_KEY,
            ASP_USER_ID: this.$store.getters["userStore/GE_USER_ROLE"].userId,
            ASP_CUST_KEY:
              this.$store.getters["userStore/GE_USER_ROLE"].company[0].CD,
          },
          {
            head: {
              SERVICE: "statistics.chat.counsel-by-agent.combobox",
              METHOD: "inqire",
              TYPE: "BIZ_SERVICE",
            },
          }
        )
        .then((response) => {
          console.log(response.data.DATA);
          this.ATRT_USER_GP = [...this.ATRT_USER_GP, ...response.data.DATA];
        })
        .catch((err) => {
          alert(err);
        });
    },

    allClick() {
      this.CHK_NEWTIME = [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
      ];
    },

    allCloseClick() {
      this.CHK_NEWTIME = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ];
    },

    async selectTime() {
      if (this.ASP_NEWCUST_KEY == "" || this.ASP_NEWCUST_KEY == undefined) {
        this.showAlert("회사를 먼저 선택해주세요.");
        return;
      }
      await api
        .post(
          "api/statistics/chat/common/start-job-time/inqire", //api url입력
          {
            ASP_NEWCUST_KEY: this.ASP_NEWCUST_KEY,
            ASP_USER_ID: this.$store.getters["userStore/GE_USER_ROLE"].userId,
            ASP_CUST_KEY:
              this.$store.getters["userStore/GE_USER_ROLE"].company[0].CD,
          },
          {
            head: {
              SERVICE: "statistics.chat.common.start-job-time",
              METHOD: "inqire",
              TYPE: "BIZ_SERVICE",
            },
          }
        )
        .then((response) => {
          var ST_TIME = response.data.DATA[0].WORK_START_TIME;

          var ST_HOUR = ST_TIME.substr(0, 2);
          this.ST_JOB_TIME = ST_HOUR;
        })
        .catch((err) => {
          alert(err);
        });

      await api
        .post(
          "api/statistics/chat/common/end-job-time/inqire", //api url입력
          {
            ASP_NEWCUST_KEY: this.ASP_NEWCUST_KEY,
            ASP_USER_ID: this.$store.getters["userStore/GE_USER_ROLE"].userId,
            ASP_CUST_KEY:
              this.$store.getters["userStore/GE_USER_ROLE"].company[0].CD,
          },
          {
            head: {
              SERVICE: "statistics.chat.common.end-job-time",
              METHOD: "inqire",
              TYPE: "BIZ_SERVICE",
            },
          }
        )
        .then((response) => {
          var END_TIME = response.data.DATA[0].WORK_END_TIME;

          var END_HOUR = END_TIME.substr(0, 2);
          this.END_JOB_TIME = END_HOUR;
        })
        .catch((err) => {
          alert(err);
        });

      this.CHK_NEWTIME = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ];

      for (
        var i = parseInt(this.ST_JOB_TIME);
        i <= parseInt(this.END_JOB_TIME);
        i++
      ) {
        if (i < 10) {
          let DB_TIME = "0" + i;
          this.CHK_NEWTIME[i] = DB_TIME;
        } else {
          this.CHK_NEWTIME[i] = i + "";
        }
      }
    },

    selectTurn() {
      var NEWTIME = [];

      for (var i = 0; i < 24; i++) {
        NEWTIME[i] = this.CHK_NEWTIME[i];
        if (i < 10) {
          if (NEWTIME[i] != "") {
            NEWTIME[i] = "";
          } else if (NEWTIME[i] == "") {
            let DB_TIME = "0" + i;
            NEWTIME[i] = DB_TIME;
          }
        } else {
          if (NEWTIME[i] != "") {
            NEWTIME[i] = "";
          } else if (NEWTIME[i] == "") {
            NEWTIME[i] = i + "";
          }
        }
      }
      this.CHK_NEWTIME = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ];
      this.CHK_NEWTIME = NEWTIME;
    },

    selectList() {
      if (this.ASP_NEWCUST_KEY == "" || this.ASP_NEWCUST_KEY == undefined) {
        this.showAlert("회사를 먼저 선택해주세요.");
        return;
      }

      let DT1 = this.dates[0];
      let DT1_Array = DT1.split("-");
      var YEAR1 = DT1_Array[0];
      var MONTH1 = DT1_Array[0] + DT1_Array[1];
      var ST_DATE = DT1_Array[0] + DT1_Array[1] + DT1_Array[2];

      let DT2 = this.dates[1];
      let DT2_Array = DT2.split("-");
      var MONTH2 = DT2_Array[0] + DT2_Array[1];
      var END_DATE = DT2_Array[0] + DT2_Array[1] + DT2_Array[2];

      api
        .post(
          "api/statistics/chat/counsel-by-agent/inqire", //api url입력
          {
            ASP_NEWCUST_KEY: this.ASP_NEWCUST_KEY,
            SEARCH_TYPE: this.SEARCH_NEWTY,
            SEARCH_FROM: ST_DATE,
            SEARCH_TO: END_DATE,
            SEARCH_MONTH_FROM: MONTH1,
            SEARCH_MONTH_TO: MONTH2,
            SEARCH_YEAR: YEAR1,
            CHK_DAY_OF_THE_WEEK_1: this.CHK_NEWDAY[0],
            CHK_DAY_OF_THE_WEEK_2: this.CHK_NEWDAY[1],
            CHK_DAY_OF_THE_WEEK_3: this.CHK_NEWDAY[2],
            CHK_DAY_OF_THE_WEEK_4: this.CHK_NEWDAY[3],
            CHK_DAY_OF_THE_WEEK_5: this.CHK_NEWDAY[4],
            CHK_DAY_OF_THE_WEEK_6: this.CHK_NEWDAY[5],
            CHK_DAY_OF_THE_WEEK_7: this.CHK_NEWDAY[6],
            SEARCH_TIME_0: this.CHK_NEWTIME[0],
            SEARCH_TIME_1: this.CHK_NEWTIME[1],
            SEARCH_TIME_2: this.CHK_NEWTIME[2],
            SEARCH_TIME_3: this.CHK_NEWTIME[3],
            SEARCH_TIME_4: this.CHK_NEWTIME[4],
            SEARCH_TIME_5: this.CHK_NEWTIME[5],
            SEARCH_TIME_6: this.CHK_NEWTIME[6],
            SEARCH_TIME_7: this.CHK_NEWTIME[7],
            SEARCH_TIME_8: this.CHK_NEWTIME[8],
            SEARCH_TIME_9: this.CHK_NEWTIME[9],
            SEARCH_TIME_10: this.CHK_NEWTIME[10],
            SEARCH_TIME_11: this.CHK_NEWTIME[11],
            SEARCH_TIME_12: this.CHK_NEWTIME[12],
            SEARCH_TIME_13: this.CHK_NEWTIME[13],
            SEARCH_TIME_14: this.CHK_NEWTIME[14],
            SEARCH_TIME_15: this.CHK_NEWTIME[15],
            SEARCH_TIME_16: this.CHK_NEWTIME[16],
            SEARCH_TIME_17: this.CHK_NEWTIME[17],
            SEARCH_TIME_18: this.CHK_NEWTIME[18],
            SEARCH_TIME_19: this.CHK_NEWTIME[19],
            SEARCH_TIME_20: this.CHK_NEWTIME[20],
            SEARCH_TIME_21: this.CHK_NEWTIME[21],
            SEARCH_TIME_22: this.CHK_NEWTIME[22],
            SEARCH_TIME_23: this.CHK_NEWTIME[23],
            USER_ATTR_A: this.USER_NEWATTR_A,
            USER_ATTR_B: this.USER_NEWATTR_B,
            USER_ATTR_C: this.USER_NEWATTR_C,
            USER_ATTR_D: this.USER_NEWATTR_D,
            USER_ID: this.USER_ID,
            USER_NM: this.USER_NM,
            USER_NICK: this.USER_NICK,
            ATRT_GROUP_ID: this.ATRT_NEWUSER_GP,
            ASP_SENDER_KEY: this.ASP_NEWSENDER_KEY,
            ASP_USER_ID: this.$store.getters["userStore/GE_USER_ROLE"].userId,
            ASP_CUST_KEY:
              this.$store.getters["userStore/GE_USER_ROLE"].company[0].CD,
          },
          {
            head: {
              SERVICE: "statistics.chat.counsel-by-agent",
              METHOD: "inqire",
              TYPE: "BIZ_SERVICE",
              ROW_CNT: "200",
              PAGES_CNT: "1",
            },
          }
        )
        .then((response) => {
          console.log(response.data.DATA);
          this.gridDataText = response.data.DATA;
          for (var i = 0; i < this.gridDataText.length; i++) {
            this.gridDataText[i]["index"] = i + 1;
          }
          this.page = 1;
        })
        .catch((err) => {
          alert(err);
        });
    },

    showDialog(menu) {
      if (this.ASP_NEWCUST_KEY == "" || this.ASP_NEWCUST_KEY == undefined) {
        this.showAlert("회사를 먼저 선택해주세요.");
        return;
      }
      this[`Dialog${menu}`] = true;
    },
    hideDialog(menu) {
      this[`Dialog${menu}`] = false;
    },

    initUser() {
      this.USER_ID = "";
      this.USER_NM = "";
      this.USER_NICK = "";
    },

    btnUser() {
      var user = {
        ASP_CUST_KEY: this.ASP_NEWCUST_KEY,
        USER_ID: this.USER_ID,
        USER_NM: this.USER_NM,
        USER_NICK: this.USER_NICK,
      };
      this.userInfo = user;
    },

    setUser() {
      this.USER_ID = this.userInfo.USER_ID;
      this.USER_NM = this.userInfo.USER_NM;
      this.USER_NICK = this.userInfo.USER_NICK;
    },

    //Table row 클릭이벤트
    rowClick(item, row) {
      this.ROW_DATA = item;
      console.log("item",item);
    },

    isActiveRow(item){
      const activeClass = item.USER_ID === this.ROW_DATA.USER_ID ? 'active' : '';
      return activeClass;
    },

    showAlert(msg) {
      this.$store.commit("alertStore/openAlertDialog", {
        alertDialogToggle: true,
        msg: msg,
        iconClass: "svg-error-lg",
        type: "default",
      });
    },

    chgChkTime(){
      let TimeArray = this.CHK_NEWTIME;
      this.CHK_NEWTIME = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ]
      for(let i = 0; i < TimeArray.length; i++){
        if(TimeArray[i] != "" || TimeArray[i] != null){
          let m = parseInt(TimeArray[i]);
          this.CHK_NEWTIME[m] = TimeArray[i];
        }
      }
     this.CHK_NEWTIME.splice(24,1);
    },

    chgChkDay(){
      let DayArray = this.CHK_NEWDAY;
      this.CHK_NEWDAY = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ]
      for(let i = 0; i < DayArray.length; i++){
        if(DayArray[i] != "" || DayArray[i] != null){
          let m = parseInt(DayArray[i])-1;
          this.CHK_NEWDAY[m] = DayArray[i];
        }
      }
     this.CHK_NEWDAY.splice(7,1);
    },

    chkInqTY(){
      if (this.SEARCH_NEWTY == "TIME"){
        let TIME_CNT = 0;
        for (let i = 0; i<this.CHK_NEWTIME.length;i++){
          if (this.CHK_NEWTIME[i] != ""){
            TIME_CNT = TIME_CNT + 1;
          }
        }
        if (TIME_CNT == 0){
          this.showAlert("조회 유형이 [시간]일 때<br>시간 조회조건이 하나 이상 필요합니다.<br><br>자동으로 [09시]를 선택합니다.");
          this.CHK_NEWTIME = [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "09",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
          ]
        }
      } else if (this.SEARCH_NEWTY == "DAY_OF_THE_WEEK"){
        let DAY_CNT = 0;
        for (let i = 0; i<this.CHK_NEWDAY.length;i++){
          if (this.CHK_NEWDAY[i] != ""){
            DAY_CNT = DAY_CNT + 1;
          }
        }
        if (DAY_CNT == 0){
          this.showAlert("조회 유형이 [요일]일 때<br>요일 조회조건이 하나 이상 필요합니다.<br><br>자동으로 [월요일]를 선택합니다.");
          this.CHK_NEWDAY = [
            "",
            "2",
            "",
            "",
            "",
            "",
            "",
          ]
        }
      }
    },

    chkNoDay(){
      let DAY_CNT = 0;
      for (let i = 0; i<this.CHK_NEWDAY.length;i++){
        if (this.CHK_NEWDAY[i] != ""){
          DAY_CNT = DAY_CNT + 1;
        }
      }
      if (DAY_CNT == 0){
        if (this.SEARCH_NEWTY == "DAY_OF_THE_WEEK"){
          this.showAlert("조회 유형이 [요일]일 때<br>요일 조회조건이 하나 이상 필요합니다.<br><br>자동으로 [월요일]를 선택합니다.");
          this.CHK_NEWDAY = [
            "",
            "2",
            "",
            "",
            "",
            "",
            "",
          ]
        }
      }
    },

    chkNoTime(){
      let TIME_CNT = 0;
      for (let i = 0; i<this.CHK_NEWTIME.length;i++){
        if (this.CHK_NEWTIME[i] != ""){
          TIME_CNT = TIME_CNT + 1;
        }
      }
      if (TIME_CNT == 0){
        if (this.SEARCH_NEWTY == "TIME"){
          this.showAlert("조회 유형이 [시간]일 때<br>시간 조회조건이 하나 이상 필요합니다.<br><br>자동으로 [09시]를 선택합니다.");
          this.CHK_NEWTIME = [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "09",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
          ]
        }
      }
    },
  },

  computed: {
    dateRangeText() {
      var newStartDate = this.dates[0];
      var newEndDate = this.dates[1];
      return newStartDate + " ~ " + newEndDate;
    },
  },
};
</script>

<style></style>
